import React from "react"
import {
  CITY_LIST_BY_PRIORITY,
  COOKIE,
  DATE_FORMATS,
  GRAPH_TYPES,
  MEDIA_TYPES,
  NUMBER_FORMATS,
  SOCIAL_SOURCES_OPTIONS,
  VERTICAL_NAMES,
} from "../constants/app-constant";
import moment from "moment";
import { getCookie } from "./cookieProvider";
import {
  printAndOnlineRegex,
  socialDetailsPageRegex,
} from "../constants/route-constants";

const {
  WORD_CLOUD
} = GRAPH_TYPES;

const { MMDDYYYY_slash, YYYYMMDD_dash, YYYYMMDD_slash, DDMMYYYY_dash } =
  DATE_FORMATS;
export const formatDate = (d = new Date(), format = YYYYMMDD_dash) => {
  try {
    const dateObj = new Date(d);
    if (!isValidDate(dateObj)) {
      return new Date();
    }
    let date = dateObj.getDate();
    date = date < 10 ? `0${date}` : date;
    let month = dateObj.getMonth() + 1;
    month = month < 10 ? `0${month}` : month;
    const year = dateObj.getFullYear();
    if (format === YYYYMMDD_dash) {
      return `${year}-${month}-${date}`;
    }
    if (format === MMDDYYYY_slash) {
      return `${month}/${date}/${year}`;
    }
    if (format === YYYYMMDD_slash) {
      return `${year}/${month}/${date}`;
    }
    if (format === DDMMYYYY_dash) {
      return `${date}-${month}-${year}`;
    }
  } catch (e) {
    return null;
  }
};

export function isValidDate(date) {
  date = new Date(date);
  if (Object.prototype.toString.call(date) === "[object Date]") {
    return !isNaN(date.getTime());
  } else {
    return false;
  }
}

export function getTrendGraphDateFormat(
  date,
  separator = "/",
  dateFormat = "DD-MM-YY"
) {
  if (!isValidDate(date)) {
    return date;
  }
  const d = moment(date).format(dateFormat);
  return d;
}

export const initials = (text = "") => {
  try {
    const tokens = text.split(" ").map((e) => e && e.toUpperCase());
    const tokensLength = tokens.length;
    if (tokensLength) {
      if (tokensLength === 1) {
        return `${tokens[0][0]}`;
      }
      let startIndex = 0;
      if (tokens[0] === "THE") {
        startIndex = 1;
      }
      const first = tokens[startIndex][0];
      const second = tokens[startIndex + 1];
      return `${first}${second && second[0] !== "(" ? second[0] : ""}`;
    }
  } catch (e) {
    return "";
  }
};

export const uniqueId = (a, b) => `${a}${b}`;

export const groupBy = (data = [], key = "id", caseInsensitive = false) => {
  try {
    let result = data.reduce(function (r, a) {
      let tmpR = {...r}
      if(a[key]){
        let groupByField = a[key].toString().trim();
        if (caseInsensitive) {
          groupByField = groupByField.toLowerCase();
        }
        tmpR[groupByField] = tmpR[groupByField] || [];
        tmpR[groupByField].push(a);
      }
      return tmpR;
    }, {});
    return result;
  } catch (e) {
    return data;
  }
};

export const getDateFormat = (d) => {
  var date = new Date(d);
  const dateFormat =
    (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) +
    "/" +
    (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
    "/" +
    date.getFullYear();
  return dateFormat;
};

export const toPascalCase = (text) => {
  try {
    const tempText = text.split("_").join(" ");
    return tempText.replace(/(\w)(\w*)/g, function (g0, g1, g2) {
      return g1.toUpperCase() + g2.toLowerCase();
    });
  } catch (e) {
    return text;
  }
};

export const arrayToString = (arr = [], toStringArray = false) => {
  const tempString = Array.isArray(arr) ? arr.join(",") : arr;
  return toStringArray ? [tempString] : tempString;
};

export const removeSpace = (data) => {
  if (!data) {
    return "";
  }
  if (!Array.isArray(data)) {
    return data.replace(/\s+/g, "");
  }
  return data.filter(function (entry) {
    return /\S/.test(entry);
  });
};

export const escapeString = (s = "",replaceString="") => {
  try {
    return replaceString == ""?s
      .replace(/&amp;/g, "&")
      .replace(/&gt;/g, ">")
      .replace(/&lt;/g, "<")
      .replace(/&quot;/g, "''")
      :s
      .replace(/&amp;/g, "&")
      .replace(/&gt;/g, ">")
      .replace(/&lt;/g, "<")
      .replace(/&quot;/g, "''")
      // .replaceString.split(",").map((rData) => {return replace(new RegExp(rData, "g"), `<label class="matchedKey">${rData}</label>`)})
      .replace(new RegExp(replaceString.split(",").join("|"), "g"), (match) => `<label class="matchedKey">${match}</label>`);
      // .replace(new RegExp(replaceString.split(",").join("|"), "g"), `<label class="matchedKey">${replaceString}</label>`);
  } catch (e) {
    return s;
  }
};

export const getStartDateTime = () => {
  const startDate = new Date();
  startDate.setHours(0, 0, 0, 0);
  return startDate.toUTCString();
};

export const getEndDateTime = () => {
  const endDate = new Date();
  endDate.setHours(23, 59, 59, 999);
  return endDate.toUTCString();
};

export const formatDateTime = (date = new Date()) => {
  const dateString = new Date(date);
  return (
    dateString.getFullYear() +
    "-" +
    ("0" + (dateString.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + dateString.getDate()).slice(-2) +
    " " +
    ("0" + dateString.getHours()).slice(-2) +
    ":" +
    ("0" + dateString.getMinutes()).slice(-2) +
    ":" +
    ("0" + dateString.getSeconds()).slice(-2)
  );
};

export const getLastWeek = (currentDate) => {
  const today = moment(currentDate).subtract(1, "day");
  const lastWeekDate = moment().subtract(1, "weeks").format("yyyy/MM/DD");
  return {
    startDate: lastWeekDate,
    endDate: today.format("yyyy/MM/DD"),
  };
};
export const getLastMonth = (currentDate) => {
  const today = moment(currentDate).subtract(1, "day");
  const lastMonthDate = moment().subtract(1, "months").format("yyyy/MM/DD");
  return {
    startDate: lastMonthDate,
    endDate: today.format("yyyy/MM/DD"),
  };
};

export const getLastTenDays = (currentDate) => {
  const today = moment(currentDate).subtract(1, "day");
  const lastTwoWeeks = moment().subtract(10, "days").format("yyyy/MM/DD");
  return {
    startDate: lastTwoWeeks,
    endDate: today.format("yyyy/MM/DD"),
  };
};

export const formatWidgetParams = (w) => {
  return {
    ...w,
    ...{
      dashboard_id: 9999,
      date_granularity: "day",
      createdAt: "2020-12-15T11:09:18.413Z",
      updatedAt: "2020-12-17T09:14:12.055Z",
    },
  };
};

export const getTime = (date) => {
  const format = "hh:mm A";
  const hours = new Date(date).getHours();
  return `${moment(date).format(format)}`;
};

export const getSearchApiDateFormat = (date) => {
  const format = "yyyy/MM/DD";
  try {
    if (typeof date == "string" && date.indexOf("-") !== -1) {
      const tokens = date.split("-");
      const [d, m, y] = [tokens[0], tokens[1], tokens[2]];
      return moment(`${m}/${d}/${y}`).format(format);
    } else {
      return moment(date).format(format);
    }
  } catch (e) {
    return moment().format(format);
  }
};

export const getShareApiDateFormat = (date) => {
  const format = "yyyy/MM/DD";
  try {
    return moment(date).format(format);
  } catch (e) {
    return moment().format(format);
  }
};

export const getCommaSeparatedNumbers = (
  rawNumber,
  formatString = NUMBER_FORMATS.EN_US
) => {
  try {
    if (!rawNumber) {
      return "NA";
    }
    const correctedNumber = parseInt(rawNumber, 10);
    var nf = new Intl.NumberFormat(formatString);
    return nf.format(correctedNumber);
  } catch (e) {
    return "NA";
  }
};

export const convertToInternationalCurrencySystem = (labelValue) => {
  if (!labelValue) return "NA";
  // Nine Zeroes for Billions
  return Math.abs(Number(labelValue)) >= 1.0e9
    ? (Math.abs(Number(labelValue)) / 1.0e9).toFixed(2) + "B"
    : // Six Zeroes for Millions
    Math.abs(Number(labelValue)) >= 1.0e6
    ? (Math.abs(Number(labelValue)) / 1.0e6).toFixed(2) + "M"
    : // Three Zeroes for Thousands
    Math.abs(Number(labelValue)) >= 1.0e3
    ? (Math.abs(Number(labelValue)) / 1.0e3).toFixed(2) + "K"
    : Math.abs(Number(labelValue));
};

export const relDiff = (a, b) => {
  return Math.abs((a - b) / (a + b));
};

export const isLoggedIn = () => {
  return getCookie(COOKIE.AUTH_TOKEN);
};

export const getConceptUserId = () => {
  return getCookie(COOKIE.CONCEPT_USER_ID);
};

export const getDayDifference = (startDate, endDate) => {
  try {
    const correctedStartDate = moment(startDate);
    const correctedEndDate = moment(endDate);
    const diffInDate = correctedStartDate.diff(correctedEndDate, "days");
    return diffInDate;
  } catch (e) {
    return 0;
  }
};

export const dateFormat = (date) => {
  const format = "MM/DD/YYYY";
  try {
    if (typeof date == "string" && date.indexOf("-") !== -1) {
      const tokens = date.split("-");
      const [y, m, d] = [tokens[0], tokens[1], tokens[2]];
      console.log(moment(`${m}/${d}/${y}`).format(format));
      return moment(`${m}/${d}/${y}`).format(format);
    } else {
      return moment(date).format(format);
    }
  } catch (e) {
    return moment().format(format);
  }
};

export const getSocialApiDateFormat = (date) => {
  const format = "MM/DD/YYYY";
  try {
    if (typeof date == "string" && date.indexOf("-") !== -1) {
      const tokens = date.split("-");
      const [d, m, y] = [tokens[0], tokens[1], tokens[2]];
      return moment(`${m}/${d}/${y}`).format(format);
    } else {
      return moment(date).format(format);
    }
  } catch (e) {
    return moment().format(format);
  }
};

export const truncate = (source = "", size = 150) => {
  try {
    return source.length > size ? source.slice(0, size - 1) + "…" : source;
  } catch (e) {
    return "";
  }
};

function onlyUniqueArrayValue(value, index, self) {
  return self.indexOf(value) === index;
}

export const getUniqueValuesFromList = (
  array,
  uniqueKeyToMatch,
  isArrayOfObject = true
) => {
  if (!isArrayOfObject) {
    var unique = array.filter(onlyUniqueArrayValue);
    return unique;
  }
  return array.filter(function (tag) {
    const key = tag[uniqueKeyToMatch];
    if (!this[key]) {
      this[key] = true;
      return true;
    }
  }, Object.create(null));
};

export const formatFollowersCount = (n) => {
  try {
    if (n < 1e3) return n;
    if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + "K";
    if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + "M";
    if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + "B";
    if (n >= 1e12) return +(n / 1e12).toFixed(1) + "T";
  } catch (e) {
    console.log(e);
    return n;
  }
};

export const formatArticleIdentifier = ({
  client_id,
  article_id,
  entity_id,
  Forclient_id,
  article_type,
}) => {
  const mediaPrefix =
    article_type === "Print" ? MEDIA_TYPES.PRINT_MV : MEDIA_TYPES.ONLINE_MV;
  return `${mediaPrefix}/${
    client_id || Forclient_id
  }-${article_id}-${entity_id}`;
};

export const sortEditions = (a, b) => {
  try {
    var editionA = a.edition.toUpperCase();
    var editionB = b.edition.toUpperCase();
    if (editionA < editionB) {
      return -1;
    }
    if (editionA > editionB) {
      return 1;
    }
    return 0;
  } catch (e) {
    return 0;
  }
};

export const filterListFromAnotherList = (array1, array2, identifierKey) => {
  const arr = array1.filter(function (arrayItem) {
    return (
      array2.filter(function (array2Item) {
        // If both list contains 1 item with same key, then it will return empty array.
        if (
          array1.length == 1 &&
          array2.length == 1 &&
          array2Item[identifierKey] == arrayItem[identifierKey]
        ) {
          return [];
        } else {
          return array2Item[identifierKey] == arrayItem[identifierKey];
        }
      }).length == 0
    );
  });
  return arr;
};

export const getKeyByValue = (object, value) => {
  if (typeof object !== "object") return "";
  return Object.keys(object).find((key) => object[key] === value);
};

export const sortArrayOfObjects = (targetArray, sortingKey, asc = true) => {
  try {
    return targetArray.sort(function (v1, v2) {
      var a =
        typeof v1[sortingKey] == "string"
          ? v1[sortingKey].toUpperCase()
          : v1[sortingKey];
      var b =
        typeof v2[sortingKey] == "string"
          ? v2[sortingKey].toUpperCase()
          : v2[sortingKey];
      if (asc) {
        if (a < b) {
          return -1;
        }
        if (a > b) {
          return 1;
        }
      } else {
        if (a > b) {
          return -1;
        }
        if (a < b) {
          return 1;
        }
      }
      return 0;
    });
  } catch (e) {
    return targetArray;
  }
};

export const getSocialPlatformIdFromName = (pName) => {
  const tempData =
    SOCIAL_SOURCES_OPTIONS.find((elm) => elm.label == pName) || {};
  return tempData && tempData.value;
};

export const getSocialPlatformNameFromID = (pId) => {
  const tempData = SOCIAL_SOURCES_OPTIONS.find((elm) => elm.value == pId) || {};
  return tempData && tempData.label;
};

export const isOpenRoute = (path) =>
  path.match(printAndOnlineRegex) || path.match(socialDetailsPageRegex);

export const isArticleRoute = (path) =>
  path.match(printAndOnlineRegex);

export const orderByCityList = (editionsList) => {
  const citiesIncludedFromCITY_LIST_BY_PRIORITY = [];
  const citiesExcludedFromCITY_LIST_BY_PRIORITY = [];

  if (editionsList.length) {
    editionsList.forEach((i) => {
      const c = CITY_LIST_BY_PRIORITY.indexOf(i.edition);
      if (c >= 0) citiesIncludedFromCITY_LIST_BY_PRIORITY.push(i);
      if (c < 0) citiesExcludedFromCITY_LIST_BY_PRIORITY.push(i);
    });
  }

  const result = [
    ...citiesIncludedFromCITY_LIST_BY_PRIORITY.sort(
      (a, b) =>
        CITY_LIST_BY_PRIORITY.indexOf(a.edition) -
        CITY_LIST_BY_PRIORITY.indexOf(b.edition)
    ),
    ...citiesExcludedFromCITY_LIST_BY_PRIORITY,
  ];
  return result;
};
export const containsNumber = (str) => {
  return /[0-9]/.test(str);
}

export function getTimelineTextPosition(str) {
  // console.log("getTimelineTextPosition", str, str.length);
  return 725 - str.length * 2.5;
  // if (moment(to_date).isSame(moment(from_date), "day")) {
  //   return 620;
  // } else {
  //   return 570;
  // }
}

export function getTimelineText(to_date,from_date,dateHash) {
  let defText = "Report for the duration ";
  if (moment(to_date).isSame(moment(from_date), "day")) {
    defText = `${defText}${getTrendGraphDateFormat(
      from_date,
      null,
      "Do MMMM YYYY"
    )}`;
  } else {
    defText = `${defText}${dateHash}`;
  }
  return defText;
}

export function getInlineFilterText(widget,selectedInlineJournalist,selectedInlinePlatform,selectedInlinePublication,selectedInlineSentiment,isBlogAndForum,isSocial,selectedInlineWCType) {
  try {
    let text = `Media Type- ${VERTICAL_NAMES[widget.type]} | `;
    if (selectedInlineJournalist && selectedInlineJournalist.label) {
      text += `Journalist- ${selectedInlineJournalist.label} | `;
    }
    if (selectedInlinePlatform) {
      text += `Platform- ${selectedInlinePlatform} | `;
    }
    if (selectedInlinePublication && selectedInlinePublication.length) {
      text += `Publication- ${selectedInlinePublication.join(",")} | `;
    }
    if (selectedInlineSentiment) {
      text += `Sentiment- ${selectedInlineSentiment} | `;
    }
    if (
      widget.graph_type == WORD_CLOUD &&
      (isBlogAndForum || isSocial) &&
      selectedInlineWCType &&
      selectedInlineWCType.label
    ) {
      text += `${selectedInlineWCType.label}  `;
    }
    return text.slice(0, -2);
  } catch (e) {
    console.warn("[Error @ widget inline filter text]: ", e);
    return "";
  }
}